import { jsx as _jsx } from "react/jsx-runtime";
import { entries } from 'lodash-es';
import { DropdownMenu, TextButton, Typography } from 'seagull';
import styles from './AddFilter.module.scss';
const AddFilter = (param)=>{
    let { filtersMap, selectedFilters, testId, onSelect, groups } = param;
    const renderItem = (type)=>/*#__PURE__*/ _jsx(DropdownMenu.Item, {
            skin: "primary",
            testId: "".concat(testId, "-filter-picker-").concat(type),
            disabled: selectedFilters.includes(type),
            onClick: ()=>onSelect(type),
            children: filtersMap[type]
        }, String(type));
    const renderGrouped = (filterGroups)=>filterGroups.flatMap((group, index)=>[
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    weight: "normal",
                    skin: "secondary",
                    className: index > 0 ? styles.groupLabelSpaced : styles.groupLabel,
                    children: group.label
                }, "group-header-".concat(group.label)),
                ...group.filters.map(renderItem)
            ]);
    const renderFlat = ()=>entries(filtersMap).map((param)=>{
            let [type, label] = param;
            return /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                skin: "primary",
                testId: "".concat(testId, "-filter-picker-").concat(type),
                disabled: selectedFilters.includes(type),
                onClick: ()=>onSelect(type),
                children: label
            }, type);
        });
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "".concat(testId, "-add-filter-container"),
        children: /*#__PURE__*/ _jsx(DropdownMenu, {
            testId: "".concat(testId, "-filter-picker"),
            hAlign: "center",
            target: /*#__PURE__*/ _jsx(TextButton, {
                testId: "".concat(testId, "-add-filter-button"),
                underline: "hover",
                bi: {
                    name: 'add_filter'
                },
                children: "+Add filter"
            }),
            children: groups ? renderGrouped(groups) : renderFlat()
        })
    });
};
export default AddFilter;
